// import moment from 'moment'
export const validatorsInitialState = {saveHit: false, msgs:{}}

export const validatorReducer = (state,action) => {
  let returnValue = {...state}
  switch (action.type) {
    case 'trial':
      if(action.data.minAge && action.data.maxAge){
        let min = parseInt(action.data.minAge)
        let max = parseInt(action.data.maxAge)
        if(max<min) returnValue = {...state, saveHit: true, msgs:{ ...state.msgs, maxAge: 'Maximum Age cannot be less than Minimum Age'}}
        else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, maxAge: null}}
      } else returnValue = {...state, ...returnValue, saveHit: true}
      if(action.data.mutationsIN.length !== 0 && action.data.mutationsOUT.length !== 0) {
        let inM = action.data.mutationsIN;
        let outM = action.data.mutationsOUT;
        inM.forEach(i => {
          if(outM.includes(i)) returnValue = {...state, saveHit: true, msgs:{...state.msgs, mutationsIN:'The same mutations cannot be listed as both Eligible and Not Eligible'}}
          else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, mutationsIN: null}}
        })
        outM.forEach(i => {
          if(inM.includes(i)) returnValue = {...state, saveHit: true, msgs:{...state.msgs, mutationsOUT:'The same mutations cannot be listed as both Eligible and Not Eligible'}}
          else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, mutationsOUT: null}}
        })
      } else returnValue = {...state, ...returnValue, saveHit: true}
      return returnValue;
    case 'registry':
      if(action.data.mutationsIN.length !== 0 && action.data.mutationsOUT.length !== 0) {
        let inM = action.data.mutationsIN;
        let outM = action.data.mutationsOUT;
        inM.forEach(i => {
          if(outM.includes(i)) returnValue = {...state, saveHit: true, msgs:{...state.msgs, mutationsIN:'The same mutations cannot be listed as both Eligible and Not Eligible'}}
          else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, mutationsIN: null}}
        })
        outM.forEach(i => {
          if(inM.includes(i)) returnValue = {...state, saveHit: true, msgs:{...state.msgs, mutationsOUT:'The same mutations cannot be listed as both Eligible and Not Eligible'}}
          else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, mutationsOUT: null}}
        })
      } else returnValue = {...state, ...returnValue, saveHit: true}
      return returnValue;
    case 'manual':
      if(action.data.title==='') returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs,title:'Study title is required'}}
      else returnValue = {...state,saveHit:true,msgs:{...state.msgs, ...returnValue.msgs, title:null}}

      if(action.data.briefDescription==='') returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs,briefDescription:'Brief description is required'}}
      else returnValue = {...state,saveHit:true,msgs:{...state.msgs, ...returnValue.msgs, briefDescription:null}}

      if(action.data.conditions==='') returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs,conditions:'At least one condition is required'}}
      else returnValue = {...state,saveHit:true,msgs:{...state.msgs, ...returnValue.msgs, conditions:null}}

      if(action.data.position==='') returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs,position:'Position in trial list is required'}}
      else returnValue = {...state,saveHit:true,msgs:{...state.msgs, ...returnValue.msgs, position:null}}

      if(action.data.minAge && action.data.maxAge){
        let min = parseInt(action.data.minAge)
        let max = parseInt(action.data.maxAge)
        if(max<min) returnValue = {...state, saveHit: true, msgs:{ ...state.msgs, maxAge: 'Maximum Age cannot be less than Minimum Age'}}
        else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, maxAge: null}}
      } else returnValue = {...state, ...returnValue, saveHit: true}
      if(action.data.mutationsIN.length !== 0 && action.data.mutationsOUT.length !== 0) {
        let inM = action.data.mutationsIN;
        let outM = action.data.mutationsOUT;
        inM.forEach(i => {
          if(outM.includes(i)) returnValue = {...state, saveHit: true, msgs:{...state.msgs, mutationsIN:'The same mutations cannot be listed as both Eligible and Not Eligible'}}
          else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, mutationsIN: null}}
        })
        outM.forEach(i => {
          if(inM.includes(i)) returnValue = {...state, saveHit: true, msgs:{...state.msgs, mutationsOUT:'The same mutations cannot be listed as both Eligible and Not Eligible'}}
          else returnValue = {...state, saveHit: true, msgs:{...state.msgs, ...returnValue.msgs, mutationsOUT: null}}
        })
      } else returnValue = {...state, ...returnValue, saveHit: true}
      return returnValue;
    default: throw new Error('unexpected action',action)
  }
}
